import React from 'react';
import { Bell, MessageSquare, Wand2, ChevronRight } from 'lucide-react';

/**
 * ActionCenter - Surface problems prominently
 * Balanced: Clean card, subtle urgency colors
 */
const ActionCenter = ({ ticketMetrics = {}, reportedIssuesCount = 0, onNavigateInbox, onViewIssues }) => {
    const openTickets = ticketMetrics.openTickets || 0;
    const unassignedTickets = ticketMetrics.unassignedTickets || 0;
    const needsAttention = openTickets > 0 || reportedIssuesCount > 0;

    const actionItems = [];

    if (openTickets > 0) {
        actionItems.push({
            id: 'tickets',
            icon: MessageSquare,
            title: `${openTickets} Open Conversation${openTickets !== 1 ? 's' : ''}`,
            subtitle: unassignedTickets > 0 ? `${unassignedTickets} need assignment` : 'All assigned',
            color: openTickets > 50 ? '#ef4444' : openTickets > 10 ? '#f59e0b' : '#3b82f6',
            onClick: onNavigateInbox
        });
    }

    if (reportedIssuesCount > 0) {
        actionItems.push({
            id: 'issues',
            icon: Wand2,
            title: `${reportedIssuesCount} Reported Issue${reportedIssuesCount !== 1 ? 's' : ''}`,
            subtitle: 'Visual bugs via Magic Wand',
            color: '#f59e0b',
            onClick: onViewIssues
        });
    }

    return (
        <div className="bg-white rounded-2xl border border-slate-200/80 p-6">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-1.5">
                    <Bell size={14} className="text-slate-400" />
                    <h3 className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Action Center</h3>
                </div>
                {needsAttention && (
                    <span className="text-[10px] font-semibold text-amber-600 bg-amber-50 px-2 py-0.5 rounded-full">
                        {actionItems.length} item{actionItems.length !== 1 ? 's' : ''}
                    </span>
                )}
            </div>

            {/* Action Items */}
            {actionItems.length > 0 ? (
                <div className="space-y-2">
                    {actionItems.map((item) => {
                        const Icon = item.icon;
                        return (
                            <button
                                key={item.id}
                                onClick={item.onClick}
                                className="w-full p-3 rounded-xl border border-slate-100 hover:border-slate-200 transition-colors text-left group"
                            >
                                <div className="flex items-center gap-3">
                                    <div
                                        className="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
                                        style={{ backgroundColor: item.color + '15' }}
                                    >
                                        <Icon size={16} style={{ color: item.color }} />
                                    </div>
                                    <div className="flex-1 min-w-0">
                                        <p className="text-sm font-medium text-slate-700">{item.title}</p>
                                        <p className="text-[11px] text-slate-400">{item.subtitle}</p>
                                    </div>
                                    <ChevronRight size={14} className="text-slate-300 group-hover:text-slate-400 transition-colors" />
                                </div>
                            </button>
                        );
                    })}
                </div>
            ) : (
                <div className="text-center py-8">
                    <div className="w-10 h-10 bg-emerald-50 rounded-xl flex items-center justify-center mx-auto mb-2">
                        <Bell size={16} className="text-emerald-500" />
                    </div>
                    <p className="text-sm font-medium text-slate-600 mb-0.5">All caught up</p>
                    <p className="text-xs text-slate-400">No items need attention</p>
                </div>
            )}
        </div>
    );
};

export default ActionCenter;
